exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#rg_map[data-v-1cb043a6]{font-size:12px;border-radius:5px!important;height:44px;background:rgba(25,35,58,.05)!important;border:0;margin-bottom:14px}", ""]);

// exports
